import { useState } from "react";
import moment from "moment";
import { Report } from "../../../services/Report";
import { useHistory } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import { useModal } from "../../../hooks/useModal";
/* Logic to remove report data */
export const useReportDataRemove = (provider_id) => {
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [channels, setChannels] = useState(null);
  const [selectedChannels, setSelectedChannels] = useState([]);

  const [isValid, setIsValid] = useState(true);
  const [removeModal, openRemoveModal, closeRemoveModal] = useModal(false);

  const history = useHistory();

  const [loadingRemovalResult, setLoadingRemovalResult] = useState({
    loading: false,
    error: false,
    success: false,
    deletedCount: 0
  });

  const handleToDate = (date) => {
    //date to be set is null , set it and return
    if (!date) {
      setToDate(null);
      return;
    }
    if (!fromDate) {
      setToDate(date);
    } else {
      if (moment(date).isAfter(fromDate) || moment(date).isSame(fromDate)) {
        setToDate(date);
      } else setToDate(fromDate);
    }
  };

  const handleFromDate = (date) => {
    //date to be set is null , set it and return
    if (!date) {
      setFromDate(null);
      return;
    }
    if (!toDate) {
      setFromDate(date);
    } else {
      if (moment(date).isBefore(toDate) || moment(date).isSame(toDate)) {
        setFromDate(date);
      } else {
        setToDate(date);
        setFromDate(date);
      }
    }
  };

  const handleDateChange = (fromDate, toDate) => {
    setLoadingRemovalResult({
      ...loadingRemovalResult,
      success: false
    });
    setFromDate(fromDate);
    setToDate(toDate);
    setIsValid(true);
  };

  const handleChannelChange = (channels) => {
    setSelectedChannels(channels);
    setIsValid(true);
  };

  const handleRemove = async () => {
    setLoadingRemovalResult({
      loading: true,
      error: false,
      success: false,
      deletedCount: 0
    });
    try {
      const payload = {
        provider_id,
        from_date: moment(fromDate).format("YYYY-MM-DD"),
        to_date: moment(toDate).format("YYYY-MM-DD")
      };
      if (selectedChannels.length > 0) {
        payload.channels = selectedChannels;
      }

      const removalResult = await Report.removeReportsDataByPubAdv(payload);
      if (removalResult.success) {
        toastr.success(
          "Success",
          `Successfully removed ${removalResult.data.revenueLogsDeleteCount} rows of data.`
        );
        setLoadingRemovalResult({
          loading: false,
          error: false,
          success: true,
          deletedCount: removalResult.data.revenueLogsDeleteCount
        });
      } else {
        throw new Error("Error while removing data");
      }
    } catch (error) {
      setLoadingRemovalResult({
        loading: false,
        error: true,
        success: false,
        deletedCount: 0
      });
      toastr.error("Error", "Sorry, unable to remove data");
    }
  };

  const validate = () => {
    if (!fromDate || !toDate) {
      setIsValid(false);
      return false;
    }
    return true;
  };

  const confirmRemoveAction = async () => {
    closeRemoveModal();
    await handleRemove();
  };

  const handleRemoveAction = async () => {
    if (!validate()) return;
    openRemoveModal();
  };

  // Redirect to Publisher Ad Account List Page
  const handleCancelAction = () => {
    history.push("/advertisers");
  };

  const loadAdvertiserChannels = async () => {
    try {
      const response = await Report.fetchChannelsByAdId({
        advertiser_id: provider_id
      });
      setChannels(
        response?.data.map((x) => ({ value: x.channel, label: x.channel }))
      );
    } catch (e) {
      toastr.error("Error", "Sorry, unable to load advertiser channels");
    }
  };

  return {
    fromDate,
    toDate,
    channels,
    setChannels,
    selectedChannels,
    setSelectedChannels,
    handleChannelChange,
    loadAdvertiserChannels,
    handleFromDate,
    handleToDate,
    handleDateChange,
    loadingRemovalResult,
    handleRemoveAction,
    isValid,
    handleCancelAction,
    confirmRemoveAction,
    removeModal,
    closeRemoveModal
  };
};
